import React, {useEffect} from 'react'
import Modal from 'react-bootstrap/Modal'
import ClassEditor from 'components/Store/ClassEditor'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import {useDispatch, useSelector} from 'react-redux'
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import * as yup from 'yup';
import FormGroup from 'components/Form/FormGroup'
import Button from 'react-bootstrap/Button'
import { saveOffering } from 'store/actions/offeringsActions'
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit';
import { deleteOffering } from 'store/actions/offeringsActions'
import analytics from 'util/analytics';
import Spinner from 'react-bootstrap/Spinner'
import FormDatePicker from 'components/Form/FormDatePicker'
import moment from 'moment-timezone'
import FormImageUploader from 'components/Form/FormImageUploader'
const DATE_FORMAT = 'ddd MMM D, YYYY';

const frequencyOptions = [
    {label: "One time payment", value: "once"},
    {label: "Subscription only", value: "subscription"},
    {label: "Promo code access", value: "promocode"},
]

const frequencyFromExpiresIn = (expiresIn) => {
    switch (expiresIn) {
    case 7:
        return "weekly"
    case 30:
        return "monthly"
    case 365:
        return "yearly"
    default:
        return "once"
    }
}

const packageTemplate = {
    id: "123456", // string: uniqueId
    partnerId: "", // string: instructor that's selling this
    type: "subscription", // string[ENUM]: package,subscription,other (choosing not to use boolean to leave room for other types in the future)
    name: "", // string
    description: "", // string
    price: 10, // double: dollars
    count: 99999, // number: to burn (very large number for subscriptions)
    expiresIn: 99999 // number: days
}

const purchaseItemTemplate = {
    offering: {
        id: "123456", // string: uniqueId
        partnerId: "", // string: instructor that's selling this
        type: "subscription", // string[ENUM]: package,subscription,other (choosing not to use boolean to leave room for other types in the future)
        name: "", // string
        description: "", // string
        price: 10, // double: dollars
        count: 99999, // number: to burn (very large number for subscriptions)
        expiresIn: 99999 // number: days
	},
    userId: "", // string: student that bought this
    remaining: 99999, // number: starts at count and burns until 0
    expires: 1592613259, // timestamp
    created: 1592613259, // timestamp
    purchased: false // default set to false. once we get a success from stripe then we'll set this to true
}

const locationTypeOptions = [
    {
        label: "In-Person Classes",
        value: "inperson"
    },
    {
        label: "Livestream Classes",
        value: "live"
    },
    {
        label: "On Demand Videos",
        value: "ondemand"
    }
]

function ChallengeEditor(props) {

    // const offerings = useSelector(state => state.instructor.offerings)
    // console.log('Offerings')
    // console.log(offerings)
    // console.trace()
    // useEffect(() => {
    //     if (offerings) {
    //         console.trace()
    //     }
    // }, [offerings])

    const dispatch = useDispatch()
    const partnerId = useSelector(state => state.instructor.instructor.platformID)

    const { toEdit } = props
    var {pack, subscription, challenge} = props
    let offeringType = ""

    var defaultDescription = ""
    var defaultDescriptionHTML = ""
    if (pack) {
        defaultDescription = `
            Redeemable for:
                * Yoga Flow LIVE classes
                * Any on-demand video
        `
        defaultDescriptionHTML = `
            <p>Redeemable for:</p> 
            <ul> 
                <li>Yoga Flow LIVE classes</li> 
                <li>Any on-demand video</li> 
            </ul>
        `

    } else if (subscription) {
        defaultDescription = `
            * Access to all of my live classes 
            * Recordings after each class 
            * Access to full on-demand video library
        `
        defaultDescriptionHTML = `
            <ul>
                <li>Access to all of my live classes</li>
                <li>Recordings after each class</li>
                <li>Access to full on-demand video library</li>
            </ul>
        `
    } else if (challenge) {

    }

    // if (toEdit) {
    //     console.log(toEdit)
    // }

    if (toEdit?.type) {
        // console.log("to edit")
        // console.log(toEdit)
        switch (toEdit.type) {
        case "pack":
            pack = true
            subscription = false
            challenge = false
            break
        case "subscription":
            pack = false
            subscription = true
            challenge = false
            break
        case "challenge":
            pack = false
            subscription = false
            challenge = true
            break
        default:
            break
        }
    }

    var viewModel = {
        placeholders: {
            name: "30-day workout challenge",
            price: "100",
            description: "Tell your students what's included"
        }
    }

    // const defualtToEdit = {...toEdit}
    const { register, control, handleSubmit, setValue, formState, errors, dirty, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            name: yup.string().required('Please enter a name'),
            description: yup.string(),
            price: yup.number().when('promoCodePurchaseOnly', {
                is: false,
                then: yup.number("Please enter a valid price greater than zero")
                // .required('Please enter a price').typeError('Please enter a valid price greater than zero')
            }),
            // price: yup.number("Please enter a valid price greater than zero").required('Please enter a price').typeError('Please enter a valid price greater than zero'),
            max_capacity: yup.number("Please enter a valid price greater than zero").required("How many people can book this challenge? Exclusivity drives demand"),
            // count: yup.number().when("type", {
            //     is: "pack",
            //     then: yup.number("Please enter a valid number grater than zero").required('Please enter a quantity').typeError('Please enter a valid number greater than zero')
            // }).typeError('Please enter a valid number greater than zero'),
            // frequency: yup.string().when("type", {
            //     is: "subscription",
            //     then: yup.string("Please enter a valid friequency").required("Please select a billing frequency").typeError('Please enter a billing frequency')
            // }),
            locationTypes: yup.array(),
            pricingOptions: yup.array().when('frequency', {
                is: "once",
                then: yup.array().of(yup.object().shape({
                        name: yup.string().required(),
                        price: yup.number().required()
                    }))
            })
        }),
        defaultValues: {
            id: toEdit?.id,
            type: "challenge",
            name: toEdit?.name ?? "",
            description: toEdit?.description ?? defaultDescription,
            descriptionHTML: toEdit?.descriptionHTML ?? defaultDescriptionHTML,
            imageUrl: toEdit?.images ? toEdit.images[0] : null,
            price: toEdit?.price,
            promoCodePurchaseOnly: toEdit?.promoCodePurchaseOnly ?? false,
            promoCode: toEdit?.promoCode,
            pricingOptions: toEdit?.pricingOptions ?? [],
            frequency: toEdit?.promoCodePurchaseOnly ? 'promocode' : (toEdit?.frequency ?? (toEdit?.expiresIn ? frequencyFromExpiresIn(toEdit.expiresIn) : null)),
            expiresIn: toEdit?.expiresIn ?? 99999,
            max_capacity: toEdit?.max_capacity ?? 1000000,
            startDate: toEdit?.startDate ? moment(toEdit.startDate * 1000).format(DATE_FORMAT) : moment().format(DATE_FORMAT),
            endDate: toEdit?.endDate ? moment(toEdit.endDate * 1000).format(DATE_FORMAT) : moment().format(DATE_FORMAT),
            // count: toEdit?.count,
            // frequency: toEdit?.expiresIn ? frequencyFromExpiresIn(toEdit.expiresIn) : null,
            // expiresIn: toEdit?.expiresIn || 99999,
            locationTypes: toEdit?.locationTypes ?? [],
            listPublicLocationTypes: toEdit?.listPublicLocationTypes ?? false
            // active: toEdit?.active || true
        }
    });


    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control,
        name: "pricingOptions"
    });


    useEffect(() => {
        register({ name: 'id'})
        // register({ name: 'isSubscription'})
        register({ name: 'type'})
        register({ name: 'imageUrl'})
        register({ name: 'promoCodePurchaseOnly'})

        // register({ name: 'pricingOptions'})
        // register({ name: 'expiresIn'})
        // register({ name: 'active'})
    }, [register])

    const [isSaving, setIsSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState(null)

    const htmlPlainText = (html) => {

        console.log("html", html)
        html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
        html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
        html = html.replace(/<\/div>/ig, '\n');
        html = html.replace(/<\/li>/ig, '\n');
        html = html.replace(/<li>/ig, '  *  ');
        html = html.replace(/<\/ul>/ig, '\n');
        html = html.replace(/<\/p>/ig, '\n');
        html = html.replace(/<br\s*[\/]?>/gi, "\n");
        html = html.replace(/<[^>]+>/ig, '');

        return html
    }


    const onSubmit = (data) => {

        console.log("Data: ", data)

        if (data.description !== toEdit?.description) {
            var description_copy = (' ' + data.description).slice(1);
            data.descriptionHTML = description_copy
            data.description = htmlPlainText(data.description)
        }
        data.count = 999999
        // if (data.promoCodePurchaseOnly) {
        //     data.price = 1000
        // }

        // console.log("data: ", data)

        if (data.imageUrl) {
            data.images = [data.imageUrl]
        } else {
            data.images = []
        }
        delete data.imageUrl

        var expiresIn = 99999 // set expiresIn based on frequency
        // if (data.frequency) {
        //     expiresIn = expiresInFromFrequency(data.frequency)
        // }

        // if (subscription) {
        //     data.count = 99999
        // }

        // if (data.isSubscription) {
        if (data.frequency === "subscription") {
            delete data.startDate
            delete data.endDate
        } else {
            if (data.startDate) {
                data.startDate = moment(data.startDate, DATE_FORMAT).startOf('day').unix()
            }
            if (data.endDate) {
                data.endDate = moment(data.endDate, DATE_FORMAT).endOf('day').unix()
            }
        }

        if (data.promoCodePurchaseOnly) {
            data.price = 1000
            data.dollarDiscount = 1000
        }

        const newData = {
            ...toEdit,
            ...data,
            expiresIn: expiresIn,
            active: true
        }

        // console.log("saving data", newData)
        // return

        setIsSaving(true)
        dispatch(saveOffering(newData))
            .then(result => {
                if (result.success === false && result.message) {
                    throw result.message
                }
                setIsSaving(false)
                if (props.onHide) {
                    props.onHide()
                }
            })
            .catch(err => {
                setIsSaving(false)
                setSaveError(err)
                window.alert(err)
            })
        
    }

    const { frequency, price } = watch()

    console.log("Errors: ", errors)

    // switch on type
    // fill viewModel placeholders with placeholders for each type
    // need to swap out "count" for "frequency" on the subscription side.
    return (
        <>
        <form onSubmit={handleSubmit(onSubmit)}>

            <FormGroup
            type="text"
            name="name"
            label="Name"
            placeholder={viewModel.placeholders.name}
            register={register}
            error={errors.name}
            fullSize
            />

            <FormImageUploader
            fullSize
            imageUrl={toEdit?.imageUrl}
            name="imageUrl"
            label="Preview Image"
            // defaultName={user.instructorProfile?.pageName}
            filePath={`users/${partnerId}/files/`}
            sublabel={"Anyone can see this image, recommended aspect ratio 16:9"}
            register={register}
            onChange={(imageUrl) => setValue('imageUrl', imageUrl)}
            imageUrl={getValues("imageUrl")}
            error={errors.imageUrl}
            // getValues={getValues}
            // fileSelection={(file) => setValue('imageUrl', file)}
            />
            

            <FormGroup
            type="text"
            texteditor
            name="description"
            label="Description"
            placeholder={viewModel.placeholders.description}
            register={register}
            error={errors.description}
            fullSize
            control={control}
            setValue={setValue}
            getValues={getValues}
            />

            {/* {pack && (
                <FormGroup
                type="number"
                name="count"
                label="Number of classes"
                placeholder="5"
                register={register}
                error={errors.count}
                fullSize
                />
            )} */}

            {/* <FormGroup 
            select
            options={frequencyOptions}
            type="text"
            name="frequency"
            label="Billing Type"
            sublabel="How often you want to charge your student"
            placeholder="Select one"
            error={errors.frequency}
            control={control}
            setValue={setValue}
            getValues={getValues}
            fullSize
            // newSelection={(val) => {
            //     console.log("frequency selection: ", val)
            //     if (val === 'once') {
            //         setValue('isSubscription', false)
            //     } else {
            //         setValue('isSubscription', true)
            //     }
            // }}
            /> */}

            <div>
                <FormGroup 
                    select
                    options={frequencyOptions}
                    type="text"
                    name="frequency"
                    label="Billing Type"
                    sublabel="How often you want to charge your student"
                    placeholder="Select one"
                    error={errors.frequency}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    fullSize
                    newSelection={(val) => {
                        setValue('pricingOptions', [])
                        if (val === 'promocode') {
                            setValue('promoCodePurchaseOnly', true)
                        } else {
                            setValue('promoCodePurchaseOnly', false)
                        }
                    }}
                />

                {(frequency === 'promocode') && (<>
                    <FormGroup
                        type="text"
                        name="promoCode"
                        label="Promo Code"
                        sublabel="(optional) Offer a promo code to drive more registrations"
                        placeholder="ROCKSTAR"
                        register={register}
                        error={errors.promoCode}
                        fullSize
                    />

                </>)}

                {fields.length === 0 && (frequency === 'once') && (<>
                    <FormGroup
                    type="number"
                    name="price"
                    label="Price"
                    placeholder={viewModel.placeholders.price}
                    register={register}
                    error={errors.price}
                    prepending={["$"]}
                    fullSize
                    />
                    
                    <div className='d-flex'>
                        <button 
                        type="button"
                        onClick={(e) => {
                            e.preventDefault()
                            append([{
                                name: "Price 1",
                                price: price
                            },{
                                name: "Price 2",
                                price: Math.round(price / 2)
                            }])
                        }}
                        className='btn btn-link ml-auto'>
                            + Add new pricing option
                            </button>
                    </div>
                </>)}

                {(frequency === 'once') && fields.map((item, index) => (
                    <div key={item.id}>
                        <FormGroup
                        type="text"
                        name={`pricingOptions[${index}].name`}
                        label={"Pricing Name " + (String(index+1))}
                        placeholder={"Pricing name"}
                        register={register}
                        fullSize
                        />

                        <FormGroup
                            className="mb-0"
                            type="number"
                            name={`pricingOptions[${index}].price`}
                            label={"Price " + (String(index+1))}
                            placeholder={viewModel.placeholders.price}
                            register={register}
                            prepending={["$"]}
                            fullSize
                        />
                        
                    </div>
                ))}


            </div>

            <hr className="my-5"></hr>
            {['once', 'promocode'].includes(frequency) && (
            <>
                <FormDatePicker
                    fullSize
                    name="startDate"
                    label="Start Date"
                    // sublabel=""
                    placeholder="Select date"
                    getValues={getValues}
                    // value={getValues('expirationDate')}
                    control={control}
                    dateFormat={DATE_FORMAT}
                />

                <FormDatePicker
                    fullSize
                    name="endDate"
                    label="End Date"
                    sublabel="If this is never ending, pick a date in the distant future"
                    placeholder="Select date"
                    getValues={getValues}
                    // value={getValues('expirationDate')}
                    control={control}
                    dateFormat={DATE_FORMAT}
                />
            </>
            )}

            <FormGroup
                type="number"
                name="max_capacity"
                label="Max Capacity"
                placeholder="Enter capacity"
                register={register}
                error={errors.max_capacity}
                fullSize
            />

            <FormGroup
                error={errors.locationTypes}
                fullSize
                select
                isMulti={true}
                options={locationTypeOptions}
                type="text"
                name="locationTypes"
                label="Public classes"
                sublabel="Do members of this community have access to classes outside of the community?"
                placeholder="Live, On Demand, In Person"
                control={control}
                setValue={setValue}
                getValues={getValues}
            />

            <FormGroup
                fullSize
                type="checkbox"
                name="listPublicLocationTypes"
                label="List public offerings"
                placeholder="Check this box if you would like public classes and/or videos to be listed inside of the community"
                register={register}
            />

            <Modal.Footer>
                <Button type="submit" variant="primary" disabled={isSaving}>
                    <span>Save changes</span>
                    {isSaving && (
                        <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden={true}
                        className="ml-2"
                      >
                        <span className="sr-only">Sending...</span>
                      </Spinner>

                    )}
                </Button>
            </Modal.Footer>

        </form>
        <DevTool control={control} />
        </>

    )
}

function ChallengeEditorModal(props) {

    const {show, onHide, toEdit} = props
    var viewModel = {
        title: toEdit ? "Edit community" : "Add new community",
        description: ""
    }

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
            keyboard={false}
            backdrop={'static'}
            >
                <Modal.Header closeButton>
                    {viewModel.title}
                </Modal.Header>
                <Modal.Body>
                    {/* <p>A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class.</p> */}
                    <p className="mb-5"><big>{viewModel.description}</big></p>
                    <ChallengeEditor
                    {...props}
                    toEdit={toEdit}
                    />
                </Modal.Body>
                
                
        </Modal>
    )
}

function NewChallengeButton(props) {

    const [newChallengeOpen, setNewChallengeOpen] = React.useState(false)
    return (
        <div>

            <ChallengeEditorModal
            {...props}
            challenge
            show={newChallengeOpen}
            onHide={() => setNewChallengeOpen(false)}
            />

            <Button onClick={() => setNewChallengeOpen(true)}>
                Add New
            </Button>
        </div>
    );
}

export default NewChallengeButton

function EditChallengeButton(props) {

    const [open, setOpen] = React.useState(false)
    return (
        <div>

            <ChallengeEditorModal 
            {...props} // includes toEdit
            show={open}
            onHide={() => setOpen(false)}
            />
            <IconButton onClick={() => {
                if (!props.toEdit) {
                    window.alert("Unable to edit class")
                }
                setOpen(true)
            }}>
                <EditIcon/>    
            </IconButton>
        </div>
    );
}

export { EditChallengeButton }

function DeleteChallengeButton(props) {

    const [alert, setAlert] = React.useState(false)
    const { toDelete } = props

    const dispatch = useDispatch()

    function handleDelete() {

        console.log("Deleting offer")
        dispatch(deleteOffering(toDelete))
            .then(res => {
                setAlert(false)
            })
    }

    function confirmDelete() {

        setAlert(
            <SweetAlert
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Are you sure you would like to remove?"
            onConfirm={() => handleDelete()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             If you do, you can no longer sell this option. Previous students who have purchased it will still be able to redeem these services.
            </SweetAlert>
        )
    }
 
    return (
        <div>
            {alert}
            <IconButton style={{color: "#ff4136"}} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon/>    
            </IconButton>
        </div>
    );
}

export {DeleteChallengeButton}